import { DynamicStandaloneByline } from '@/components/Byline';
import { LabradorComponent } from '@/types/component';
import withDebugMetadata from '@/utils/withDebugMetadata';

const LabradorByline: LabradorComponent = ({ type, data, meta }) => {
  // TODO: Check descendants for an image. If there is one, use that instead of the default one
  const author = [data.firstName, data.lastName].filter(Boolean).join(' ');

  return (
    <DynamicStandaloneByline
      authorPageSlug={data.authorPageSlug}
      type={data.type}
      author={author}
      image={data.image}
      text={data.text}
      options={data.options}
      {...withDebugMetadata({ type, meta })}
    />
  );
};

export default LabradorByline;
